import { render, staticRenderFns } from "./SavedForumPostCard.vue?vue&type=template&id=558b3958&scoped=true&"
import script from "./SavedForumPostCard.vue?vue&type=script&lang=js&"
export * from "./SavedForumPostCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558b3958",
  null
  
)

export default component.exports